import { Icon, Text } from '@kanda-libs/ks-design-library';

interface BulletListHorizontalProps {
  bullets: {
    title: string;
    subText?: string;
  }[];
}

const BulletListHorizontal = ({ bullets }: BulletListHorizontalProps) => (
  <div className="flex flex-col w-full md:flex-row flex-wrap gap-x-4 gap-y-4">
    {bullets.map((bullet) => (
      <div key={bullet.title} className="flex flex-col gap-y-1 flex-1 min-w-40">
        <div className="flex flex-row">
          <div className="flex p-1.5 rounded-full bg-purple-100 mr-3 mb-auto">
            <Icon icon="check" stroke="purple-500" size={12} />
          </div>
          <Text
            text={bullet.title}
            className="text-16-20-em mt-0.5 mb-auto text-neutral-700 w-full"
          />
        </div>
        {bullet.subText && (
          <Text
            text={bullet.subText}
            className="flex text-14-22 text-neutral-700"
          />
        )}
      </div>
    ))}
  </div>
);

export default BulletListHorizontal;
